<app-header></app-header>
<div class="row finzy-main-row">
    <app-investormenu></app-investormenu>

    <div class="col-xs-12 col-md-10">
        <div class="col-md-12">
            <ng-container *ngIf="!isFINXLender">
                <div class="col-md-6 col-md-offset-3">
                    <div class="row finzy-prov-div">
                        <p class="finzy-prov-1">Your Provisional Certificate</p>
                        <p class="finzy-prov-2">You can generate and download your provisional interest certificate by
                            clicking on the button below.</p>
                        <div class="row" style="margin-top: 10px">
                            <mat-spinner [diameter]="35" *ngIf="shouldShowProvisionalCertificatedFormLoader"
                                        style="margin: auto;"></mat-spinner>
                            <form [formGroup]="provisionalCertificateForm.form" *ngIf="isProvisionalCertificateFormEnabled">
                                <mat-form-field>
                                    <mat-select placeholder="Select Financial Year"
                                                [required]="true"
                                                [formControlName]="provisionalCertificateForm.SelectedFinancialYearControlName">
                                        <mat-option *ngFor="let year of financialYears" [value]="year">
                                            {{ year }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="provisionalCertificateForm.isSelectedFinancialYearValid()">
                                        Please select a financial year.
                                    </mat-error>
                                </mat-form-field>
                            </form>
                        </div>
                        <div class="row" style="margin-top: 10px">
                            <button mat-flat-button class="primary" (click)="validateAndGenerateProvisionalCertificate()"
                                    *ngIf="!shouldShowProvisionalCertificateLoader">
                                GET YOUR INTEREST CERTIFICATE
                            </button>
                            <mat-spinner [diameter]="35" class="mat-spinner col-md-offset-5 center-block"
                                        *ngIf="shouldShowProvisionalCertificateLoader"></mat-spinner>
                        </div>
                    </div>
                </div>
                <div id="final-certificate-container" class="col-md-6 col-md-offset-3">
                    <p class="finzy-prov-1 col-md-12 text-center">Final Certificates</p>
                    <p class="text-center">Your final interest certificate for the previous financial year will be made
                        available to
                        you by the 30th of April. You can download the certificates for earlier years below.</p>
                    <div *ngIf="!shouldShowFinalCertificatesLoader">
                        <mat-table [dataSource]="finalInterestCertificateDataSource"
                                *ngIf="shouldShowFinalCertificatesTable"
                                class="col-md-offset-1 col-md-12" matSort>
                            <ng-container matColumnDef="financialYear">
                                <mat-header-cell *matHeaderCellDef>Financial Year</mat-header-cell>
                                <mat-cell
                                        *matCellDef="let interestCertificate"> {{interestCertificate.financialYear}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="downloadUrl">
                                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                <mat-cell *matCellDef="let interestCertificate">
                                    <a (click)="downloadInterestCertificateFile(interestCertificate.financialYear)">Download</a>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="downloadStatementOfReturn">
                                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                <mat-cell *matCellDef="let interestCertificate">
                                    <a *ngIf="interestCertificate.statementOfReturnDownloadUrl"
                                    (click)="downloadStatementOfReturnsFile(interestCertificate.financialYear)">Statement Of Returns</a>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row
                                    *matHeaderRowDef="finalInterestCertificateColumnsToBeDisplayed"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: finalInterestCertificateColumnsToBeDisplayed;"></mat-row>
                        </mat-table>
                        <div *ngIf="!shouldShowFinalCertificatesTable" id="no-final-certificates-available-section"
                            class="text-center">
                            <p>There are no final certificates available for you at the moment.</p>
                        </div>
                    </div>
                    <mat-spinner [diameter]="35" class="mat-spinner col-xs-6 col-xs-offset-6"
                                *ngIf="shouldShowFinalCertificatesLoader"></mat-spinner>
                </div>
            </ng-container>
            <ng-container *ngIf="isFINXLender">
                <div class="col-md-6 col-md-offset-3">
                    <div class="row finzy-prov-div">
                        <p class="finzy-prov-2">To get your interest certificate please write to <a href="mailto:support@finzy.com" target="_blank">support@finzy.com</a></p>
                    </div>
                </div>
            </ng-container>
            <div class="row">
                <p class="finzy-p6 col-md-6 col-md-offset-3">If you need assistance you can find help <a
                        [routerLink]="['/faq']">here</a>. You could
                    even call us on <a class="phone-number" href="tel:9341300300" rel="nofollow">9341 300 300</a>. We
                    are always happy to help!</p>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
